module.exports = __webpack_public_path__ + "img/dp-jy-qt3.1ae949c8.png";